import React from 'react';

interface ArrayInputFieldProps {
  label: string;
  value: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
  maxItems?: number;
  helpText?: string;
}

// 旧 styled 定義をそのまま Tailwind クラス文字列にした定数。
const CONTAINER = 'mb-5';
const LABEL = 'block mb-2 text-[14px] font-semibold text-[#333]';
const HELP_TEXT = '-mt-1 mb-2 text-[12px] text-[#666]';
const INPUT_WRAPPER = 'flex gap-2 mb-3';
const INPUT =
  'flex-1 px-3 py-2.5 border border-[#ddd] rounded-md text-[14px] transition-[border-color] duration-200 ease-[ease] focus:outline-none focus:border-[#4CAF50] disabled:bg-[#f5f5f5] disabled:cursor-not-allowed';
const ADD_BUTTON =
  'px-5 py-2.5 border-0 rounded-md bg-[#4CAF50] text-white text-[14px] font-medium cursor-pointer transition-[background-color] duration-200 ease-[ease] enabled:hover:bg-[#45a049] disabled:bg-[#ccc] disabled:cursor-not-allowed';
const ITEMS_LIST = 'flex flex-col gap-2 mb-3';
const ITEM =
  'flex items-center justify-between px-3 py-2.5 bg-[#f9f9f9] border border-[#e0e0e0] rounded-md';
const ITEM_TEXT = 'flex-1 text-[14px] text-[#333]';
const REMOVE_BUTTON =
  'flex items-center justify-center w-6 h-6 border-0 rounded-full bg-[#ff5252] text-white text-[18px] leading-none cursor-pointer transition-[background-color] duration-200 ease-[ease] hover:bg-[#ff1744]';
const COUNTER = 'text-right text-[12px] text-[#666]';

export const ArrayInputField: React.FC<ArrayInputFieldProps> = ({
  label,
  value,
  onChange,
  placeholder = '',
  maxItems = 20,
  helpText
}) => {
  const [inputValue, setInputValue] = React.useState('');

  const handleAdd = () => {
    if (inputValue.trim() && value.length < maxItems) {
      onChange([...value, inputValue.trim()]);
      setInputValue('');
    }
  };

  const handleRemove = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAdd();
    }
  };

  return (
    <div className={CONTAINER}>
      <label className={LABEL}>{label}</label>
      {helpText && <p className={HELP_TEXT}>{helpText}</p>}

      <div className={INPUT_WRAPPER}>
        <input
          className={INPUT}
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          disabled={value.length >= maxItems}
        />
        <button
          className={ADD_BUTTON}
          type="button"
          onClick={handleAdd}
          disabled={!inputValue.trim() || value.length >= maxItems}
        >
          追加
        </button>
      </div>

      {value.length > 0 && (
        <div className={ITEMS_LIST}>
          {value.map((item, index) => (
            <div className={ITEM} key={index}>
              <span className={ITEM_TEXT}>{item}</span>
              <button className={REMOVE_BUTTON} type="button" onClick={() => handleRemove(index)}>
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      <div className={COUNTER}>
        {value.length} / {maxItems}
      </div>
    </div>
  );
};
